// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-nav .sidebar-header {
  background: #213046;
}
.sidebar-nav .navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 10rem;
  list-style: none;
}
.sidebar-nav .navbar-nav i {
  width: 25px;
  text-align: center;
  margin-right: 0.5rem;
}
.sidebar-nav .navbar-nav .nav-item .nav-link,
.sidebar-nav .navbar-nav .HasChild.nav-link {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.95rem 1rem;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar-nav .navbar-nav .nav-item .nav-link:hover, .sidebar-nav .navbar-nav .nav-item .nav-link.active,
.sidebar-nav .navbar-nav .HasChild.nav-link:hover,
.sidebar-nav .navbar-nav .HasChild.nav-link.active {
  background: #10151C;
  color: hsla(0, 0%, 100%, 0.8);
}
.sidebar-nav .navbar-nav .nav-item .nav-link:hover i, .sidebar-nav .navbar-nav .nav-item .nav-link.active i,
.sidebar-nav .navbar-nav .HasChild.nav-link:hover i,
.sidebar-nav .navbar-nav .HasChild.nav-link.active i {
  font-weight: 900;
}
.sidebar-nav .collapse,
.sidebar-nav .collapsing {
  background: #131b25;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 37, 41, 0.15) inset;
}
.sidebar-nav .collapse .collapse-inner,
.sidebar-nav .collapsing .collapse-inner {
  min-width: 10rem;
  font-size: 0.85rem;
}
.sidebar-nav .collapse .collapse-inner .collapse-item,
.sidebar-nav .collapsing .collapse-inner .collapse-item {
  padding: 0.9rem 1.8rem;
  display: block;
  color: #3a3b45;
  text-decoration: none;
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar-nav .collapse .collapse-inner .collapse-item:hover, .sidebar-nav .collapse .collapse-inner .collapse-item.active,
.sidebar-nav .collapsing .collapse-inner .collapse-item:hover,
.sidebar-nav .collapsing .collapse-inner .collapse-item.active {
  background: #10151C;
  color: hsla(0, 0%, 100%, 0.8);
}
.sidebar-nav .collapse .collapse-inner .collapse-item:hover i, .sidebar-nav .collapse .collapse-inner .collapse-item.active i,
.sidebar-nav .collapsing .collapse-inner .collapse-item:hover i,
.sidebar-nav .collapsing .collapse-inner .collapse-item.active i {
  font-weight: 900;
}
.sidebar-nav .sidebar-nav-footer {
  background: #232F3E;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.sidebar-nav .sidebar-nav-footer .logout {
  color: #8a8a8a !important;
}
.sidebar-nav .sidebar-nav-footer .logout i {
  width: 25px;
  text-align: center;
  margin-right: 0.5rem;
}

.notification ul {
  padding: 0px;
  margin: 0;
}
.notification ul li {
  list-style: none;
}
.notification ul li .drop-title {
  font-weight: 500;
  padding: 2px 20px 5px;
  border-bottom: 1px solid rgba(120, 130, 140, 0.13);
}
.notification ul li .nav-link {
  border-top: 1px solid rgba(120, 130, 140, 0.13);
  padding-top: 5px;
  padding-bottom: 0;
  color: #333333;
}
.notification ul .notification-center {
  width: 230px;
  height: 220px;
  overflow: auto;
  position: relative;
}
.notification ul .notification-center a {
  border-bottom: 1px solid rgba(120, 130, 140, 0.13);
  display: block;
  text-decoration: none;
  padding: 0px 15px;
}
.notification ul .notification-center a:hover {
  background: #f2f4f8;
}
.notification ul .notification-center a .notification-contnet {
  display: inline-block;
  width: 70%;
  vertical-align: middle;
  padding-left: 10px;
}
.notification ul .notification-center a .notification-contnet h5 {
  color: #232F3E;
  margin: 5px 0px 0;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.notification ul .notification-center a .notification-contnet .mail-desc {
  font-size: 14px !important;
}
.notification ul .notification-center a .notification-contnet .mail-desc,
.notification ul .notification-center a .notification-contnet .time {
  font-size: 12px;
  display: block;
  margin: 1px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #67757c;
  white-space: nowrap;
}

.top-header {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1019607843);
}
.top-header .search {
  position: relative;
}
.top-header .search i {
  font-size: 16px;
  color: #9f9f9f;
  position: absolute;
  top: 10px;
  left: 10px;
}
.top-header .search .search-bar {
  padding-left: 35px;
}
.top-header .navbar-nav {
  align-items: center;
}
.top-header .navbar-nav .nav-item .nav-link span i {
  font-size: 1.25rem;
}
.top-header .navbar-nav .nav-item .nav-link span i::after {
  position: absolute;
  content: "";
  background-color: #f81201;
  top: -5px;
  right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.top-header .navbar-nav .no-arrow.dropdown.nav-item .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}
.top-header .navbar-nav .profile-img {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 20px;
}
.top-header .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.top-header .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.top-header .dropdown-menu {
  border: none;
  animation-name: slideIn;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 37, 41, 0.15);
}
@media (min-width: 992px) {
  .top-header .dropdown-menu {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }
}
@keyframes slideIn {
  0% {
    transform: translateY(1rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0rem);
    opacity: 1;
  }
  0% {
    transform: translateY(1rem);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/navbars/_navbar.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AADR;AAGQ;EACI,WAAA;EACA,kBAAA;EACA,oBAAA;AADZ;AAMQ;;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,+BAAA;AAJZ;AAMY;;;EAEI,mBAAA;EACA,6BAAA;AAHhB;AAKgB;;;EACI,gBAAA;AADpB;AAOI;;EAEI,mBAAA;EACA,4DAAA;AALR;AAOQ;;EACI,gBAAA;EACA,kBAAA;AAJZ;AAMY;;EACI,sBAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;AAHhB;AAKgB;;;EAEI,mBAAA;EACA,6BAAA;AAFpB;AAIoB;;;EACI,gBAAA;AAAxB;AAOI;EACI,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AALR;AAOQ;EACI,yBAAA;AALZ;AAOY;EACI,WAAA;EACA,kBAAA;EACA,oBAAA;AALhB;;AAYA;EACI,YAAA;EACA,SAAA;AATJ;AAWI;EACI,gBAAA;AATR;AAWQ;EACI,gBAAA;EACA,qBAAA;EACA,kDAAA;AATZ;AAYQ;EACI,+CAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAVZ;AAeI;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAbR;AAeQ;EACI,kDAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAbZ;AAeY;EACI,mBAAA;AAbhB;AAgBY;EACI,qBAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;AAdhB;AAgBgB;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAdpB;AAiBgB;EACI,0BAAA;AAfpB;AAkBgB;;EAEI,eAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhBpB;;AAuBA;EACI,oDAAA;AApBJ;AAsBI;EACI,kBAAA;AApBR;AAsBQ;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AApBZ;AAuBQ;EACI,kBAAA;AArBZ;AAyBI;EACI,mBAAA;AAvBR;AA0BY;EACI,kBAAA;AAxBhB;AA0BgB;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAxBpB;AA6BQ;EACI,cAAA;EACA,iBAAA;AA3BZ;AA8BQ;EACI,sCAAA;EACA,mBAAA;AA5BZ;AA8BY;EACI,WAAA;EACA,YAAA;AA5BhB;AAgCgB;EACI,eAAA;EACA,gBAAA;AA9BpB;AAoCI;EACI,YAAA;EACA,uBAAA;EACA,sDAAA;AAlCR;AAoCQ;EACI;IACI,wBAAA;IACA,yBAAA;EAlCd;AACF;AAsCI;EACI;IACI,2BAAA;IACA,UAAA;EApCV;EAuCM;IACI,2BAAA;IACA,UAAA;EArCV;EAwCM;IACI,2BAAA;IACA,UAAA;EAtCV;AACF","sourcesContent":[".sidebar-nav {\n    .sidebar-header {\n        background: #213046;\n    }\n\n    .navbar-nav {\n        display: flex;\n        flex-direction: column;\n        padding-left: 0;\n        margin-bottom: 10rem;\n        list-style: none;\n\n        i {\n            width: 25px;\n            text-align: center;\n            margin-right: 0.5rem\n        }\n\n\n\n        .nav-item .nav-link,\n        .HasChild.nav-link {\n            display: block;\n            width: 100%;\n            text-align: left;\n            padding: 0.95rem 1rem;\n            color: rgba(255, 255, 255, 0.5);\n\n            &:hover,\n            &.active {\n                background: #10151C;\n                color: hsla(0, 0%, 100%, 0.8);\n\n                i {\n                    font-weight: 900;\n                }\n            }\n        }\n    }\n\n    .collapse,\n    .collapsing {\n        background: #131b25;\n        box-shadow: 0 .15rem 1.75rem 0 rgba(33, 37, 41, .15) inset;\n\n        .collapse-inner {\n            min-width: 10rem;\n            font-size: .85rem;\n\n            .collapse-item {\n                padding: 0.9rem 1.8rem;\n                display: block;\n                color: #3a3b45;\n                text-decoration: none;\n                white-space: nowrap;\n                color: rgba(255, 255, 255, 0.5);\n\n                &:hover,\n                &.active {\n                    background: #10151C;\n                    color: hsla(0, 0%, 100%, 0.8);\n\n                    i {\n                        font-weight: 900;\n                    }\n                }\n            }\n        }\n    }\n\n    .sidebar-nav-footer {\n        background: #232F3E;\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n\n        .logout {\n            color: #8a8a8a !important;\n\n            i {\n                width: 25px;\n                text-align: center;\n                margin-right: 0.5rem\n            }\n        }\n    }\n}\n\n\n.notification ul {\n    padding: 0px;\n    margin: 0;\n\n    li {\n        list-style: none;\n\n        .drop-title {\n            font-weight: 500;\n            padding: 2px 20px 5px;\n            border-bottom: 1px solid rgba(120, 130, 140, 0.13);\n        }\n\n        .nav-link {\n            border-top: 1px solid rgba(120, 130, 140, 0.13);\n            padding-top: 5px;\n            padding-bottom: 0;\n            color: #333333;\n        }\n\n    }\n\n    .notification-center {\n        width: 230px;\n        height: 220px;\n        overflow: auto;\n        position: relative;\n\n        a {\n            border-bottom: 1px solid rgba(120, 130, 140, 0.13);\n            display: block;\n            text-decoration: none;\n            padding: 0px 15px;\n\n            &:hover {\n                background: #f2f4f8;\n            }\n\n            .notification-contnet {\n                display: inline-block;\n                width: 70%;\n                vertical-align: middle;\n                padding-left: 10px;\n\n                h5 {\n                    color: #232F3E;\n                    margin: 5px 0px 0;\n                    font-size: 16px;\n                    white-space: nowrap;\n                    text-overflow: ellipsis;\n                    overflow: hidden;\n                }\n\n                .mail-desc {\n                    font-size: 14px !important;\n                }\n\n                .mail-desc,\n                .time {\n                    font-size: 12px;\n                    display: block;\n                    margin: 1px 0;\n                    text-overflow: ellipsis;\n                    overflow: hidden;\n                    color: #67757c;\n                    white-space: nowrap;\n                }\n            }\n        }\n    }\n}\n\n.top-header {\n    box-shadow: 0px 3px 20px #0000001A;\n\n    .search {\n        position: relative;\n\n        i {\n            font-size: 16px;\n            color: #9f9f9f;\n            position: absolute;\n            top: 10px;\n            left: 10px;\n        }\n\n        .search-bar {\n            padding-left: 35px;\n        }\n    }\n\n    .navbar-nav {\n        align-items: center;\n\n        .nav-item .nav-link {\n            span i {\n                font-size: 1.25rem;\n\n                &::after {\n                    position: absolute;\n                    content: '';\n                    background-color: #f81201;\n                    top: -5px;\n                    right: 5px;\n                    width: 8px;\n                    height: 8px;\n                    border-radius: 50%;\n                }\n            }\n        }\n\n        .no-arrow.dropdown.nav-item .nav-link {\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n\n        .profile-img {\n            border: 1px solid rgba(0, 0, 0, 0.125);\n            border-radius: 20px;\n\n            img {\n                width: 35px;\n                height: 35px;\n            }\n\n            .text {\n                .profile-name {\n                    font-size: 14px;\n                    line-height: 6px;\n                }\n            }\n        }\n    }\n\n    .dropdown-menu {\n        border: none;\n        animation-name: slideIn;\n        box-shadow: 0 .15rem 1.75rem 0 rgba(33, 37, 41, .15);\n\n        @media (min-width: 992px) {\n            & {\n                animation-duration: 0.3s;\n                animation-fill-mode: both;\n            }\n        }\n    }\n\n    @keyframes slideIn {\n        0% {\n            transform: translateY(1rem);\n            opacity: 0;\n        }\n\n        100% {\n            transform: translateY(0rem);\n            opacity: 1;\n        }\n\n        0% {\n            transform: translateY(1rem);\n            opacity: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
